import { css } from '@microsoft/fast-element';

export const FileUploadStyles = css`
  .upload-rectangule {
    width: 100%;
    height: 210px;
    padding: 16px;
    border: 1px dashed rgb(255 255 255 / 27%);
    background-color: rgb(242 35 100 / 0%);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .title {
    margin-bottom: 0;
  }

  .file {
    margin-top: 0;
    font-size: 13px;
    color: rgb(241 241 241 / 51%);
  }
`;
